import React, { Fragment, useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Link, useNavigate } from "react-router-dom";
import SvgIcon from "../../Components/Common/Component/SvgIcon";
import CustomizerContext from "../../_helper/Customizer";
import { MENUITEMS } from "./Menu";
import { useDispatch } from "react-redux";
import { additem } from "../../utils/supportrequestSlice";
// import FontawesomeIcon from "../../Components/Icons/FontawesomeIcon";
import {
  FaCalendar,
  FaCalendarAlt,
  FaChartBar,
  FaClock,
  FaFileAlt,
  FaFileInvoiceDollar,
  FaRupeeSign,
  FaSignOutAlt,
  FaTasks,
  FaUser,
} from "react-icons/fa";
import { IoChatboxEllipses } from "react-icons/io5";
import { AiFillDashboard } from "react-icons/ai";
import { IoIosPerson, IoMdCalendar } from "react-icons/io";
import { MdAssignment, MdPause } from "react-icons/md";
import { TiTime } from "react-icons/ti";
import { ToastContainer } from "react-toastify";
import { FiLogIn } from "react-icons/fi";
import Swal from "sweetalert2";
import {
  FaClipboardList,
  FaMinus,
  FaListUl,
  FaUserMinus,
  FaListAlt,
  FaClipboardCheck,
} from "react-icons/fa";
import { Badge } from "reactstrap";
import { useSelector } from "react-redux";
import { clearDraftsOnLogout } from "../../utils/draftSlice";

const SidebarMenuItems = ({
  setMainMenu,
  sidebartoogle,
  setNavActive,
  activeClass,
}) => {
  const { mixLayout, toggleSidebar, toggleIcon, layout, layoutURL } =
    useContext(CustomizerContext);

  const openCloseSidebar = () => {
    toggleSidebar(!toggleIcon);
  };

  const layout1 = localStorage.getItem("sidebar_layout") || layout;
  const notificationCount = useSelector(
    (state) => state?.users?.notiTotalCount
  );

  const CurrentPath = window.location.pathname;
  const history = useNavigate();
  const dispatch = useDispatch();
  const baseurl = useSelector((store) => store.baseUrl);
  const [selectedItem, setSelectedItem] = useState(() => {
    const savedItem = sessionStorage.getItem("selectedSidebar");
    return savedItem != null ? JSON.parse(savedItem) : 0;
  });

  const is_admin = localStorage.getItem("is_admin");
  const showtask = localStorage.getItem("showtask");

  const handleItemClick = (index, title, type) => {
    const currentSelectedSidebar = JSON.parse(
      sessionStorage.getItem("selectedSidebar")
    );

    if (window.innerWidth <= 768 && type != "sub") {
      openCloseSidebar();
    }

    if (title == "Chat") {
      if (currentSelectedSidebar == index) {
        return;
      }
      const newTab = window.open(`${baseurl}/timesheetportal/#/chat`, "_blank");
      newTab.onload = () => {
        newTab.sessionStorage.setItem("selectedSidebar", JSON.stringify(index));
      };
    } else if (title != "Logout" && title != "Chat") {
      sessionStorage.setItem("selectedSidebar", JSON.stringify(index));
      setSelectedItem(index);
    }
  };

  useEffect(() => {
    const savedItem = sessionStorage.getItem("selectedSidebar");
    if (savedItem != null) {
      setSelectedItem(JSON.parse(savedItem));
    }
  }, [selectedItem]);

  const { t } = useTranslation();
  const toggletNavActive = (item) => {
    if (window.innerWidth <= 991) {
      document.querySelector(".page-header").className =
        "page-header close_icon";
      document.querySelector(".sidebar-wrapper").className =
        "sidebar-wrapper close_icon";

      if (item.type == "sub") {
        document.querySelector(".page-header").className = "page-header";
        document.querySelector(".sidebar-wrapper").className =
          "sidebar-wrapper";
      }
    }

    // Determine if the clicked item is a child of a sub-menu
    let isChildItem = false;
    let parentMenuItem = null;
    MENUITEMS.forEach((a) => {
      a.Items.forEach((menuItem) => {
        if (menuItem.children) {
          menuItem.children.forEach((childItem) => {
            if (childItem == item) {
              isChildItem = true;
              parentMenuItem = menuItem;
            }
            if (childItem.children) {
              childItem.children.forEach((grandchildItem) => {
                if (grandchildItem == item) {
                  isChildItem = true;
                  parentMenuItem = menuItem;
                }
              });
            }
          });
        }
      });
    });

    // Close all sub-menus except the clicked item or its parent
    MENUITEMS.forEach((a) => {
      a.Items.forEach((menuItem) => {
        if (menuItem != item && menuItem != parentMenuItem) {
          menuItem.active = false;
          if (menuItem.children) {
            menuItem.children.forEach((childItem) => {
              childItem.active = false;
              if (childItem.children) {
                childItem.children.forEach((grandchildItem) => {
                  grandchildItem.active = false;
                });
              }
            });
          }
        }
      });
    });

    // Toggle the active state of the clicked item
    item.active = !item.active;

    // If it's a child item, ensure the parent remains active
    if (isChildItem && parentMenuItem) {
      parentMenuItem.active = true;
    }

    setMainMenu({ mainmenu: MENUITEMS });
  };

  const clearLocalStorageAndLogout = () => {
    localStorage.clear();
    sessionStorage.clear();
    dispatch(clearDraftsOnLogout()); // Clear drafts from Redux
    history(`${process.env.PUBLIC_URL}/login`);
    dispatch(additem([]));
  };

  const Logout = () => {
    Swal.fire({
      title: "Are you sure you want to logout?",
      text: "You will need to log in again to access your account.",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, logout",
    }).then((result) => {
      if (result.isConfirmed) {
        // Bypass punchin/punchout checks for POS systems
        if (process.env.REACT_APP_IS_POS != "0") {
          clearLocalStorageAndLogout();
          return;
        }

        // Original punchin/punchout logic for non-POS systems
        const punchin = JSON.parse(localStorage.getItem("punchin"));
        const punchout = JSON.parse(localStorage.getItem("punchout"));

        if (punchin == null && punchout == null) {
          clearLocalStorageAndLogout();
        } else if (punchin == false && punchout == true) {
          Swal.fire(
            "Please remember to perform a punch-out before logging out of the system!",
            "",
            "info"
          );
        } else if (punchin == false && punchout == false) {
          clearLocalStorageAndLogout();
        } else if (punchin == true) {
          clearLocalStorageAndLogout();
        }
      }
    });
  };

  // Filter menu items based on showtask and is_admin
  const filterMenuItems = (items) => {
    return items.map((item) => ({
      ...item,
      Items: item.Items.filter((menuItem) => {
        // Filter top-level items
        if (menuItem.title == "My tasks" && showtask != "Y") {
          return false;
        }
        if (
          [
            "Missing Logout list",
            "Leave Approval list",
            "Attendence Report",
            "Monthly Timesheet Report",
            "Employeewise Report",
          ].includes(menuItem.title) &&
          is_admin != "Y"
        ) {
          return false;
        }
        if (menuItem.title == "My Absent list" && is_admin == "Y") {
          return false;
        }

        // Filter children for sub-menus
        if (menuItem.children) {
          menuItem.children = menuItem.children.filter((childItem) => {
            if (
              childItem.title == "My tasks" &&
              showtask != "Y" &&
              (menuItem.title == "Timesheet report" ||
                menuItem.title == "Working hours")
            ) {
              return false;
            }
            return true;
          });
        }

        return true;
      }),
    }));
  };

  const filteredMenuItems = filterMenuItems(MENUITEMS);

  return (
    <>
      {filteredMenuItems.map((Item, i) => (
        <Fragment key={i}>
          <li className="sidebar-main-title">
            <div>
              <h6 className="lan-1">{t(Item.menutitle)}</h6>
            </div>
          </li>
          {Item.Items.map((menuItem, i) => (
            <li className="sidebar-list" key={i}>
              {menuItem.type == "sub" ? (
                <a
                  href="javascript"
                  className={`sidebar-link sidebar-title d-flex ${CurrentPath.includes(menuItem.title.toLowerCase())
                      ? "active"
                      : ""
                    } ${i == selectedItem ? "sidebar-selected" : ""}`}
                  onClick={(event) => {
                    event.preventDefault();
                    setNavActive(menuItem);
                    activeClass(menuItem.active);
                    handleItemClick(i, menuItem?.title, menuItem?.type);
                  }}
                >
                  {menuItem.title == "Timesheet report" && (
                    <FaCalendar
                      className={`sidebar-icon ${i == selectedItem ? "sidebar-selected" : ""
                        }`}
                    />
                  )}
                  {menuItem.title == "Working hours" && (
                    <FaClock
                      className={`sidebar-icon ${i == selectedItem ? "sidebar-selected" : ""
                        }`}
                    />
                  )}
                  <span
                    className={`${i == selectedItem ? "sidebar-selected" : ""}`}
                    style={{ fontSize: "13px" }}
                  >
                    {t(menuItem.title)}
                  </span>
                  {menuItem.badge ? (
                    <label className={menuItem.badge}>
                      {menuItem.badgetxt}
                    </label>
                  ) : (
                    ""
                  )}
                  <div className="according-menu">
                    {menuItem.active ? (
                      <i
                        className={`fa fa-angle-down ${i == selectedItem ? "sidebar-selected" : ""
                          }`}
                      ></i>
                    ) : (
                      <i
                        className={`fa fa-angle-right ${i == selectedItem ? "sidebar-selected" : ""
                          }`}
                      ></i>
                    )}
                  </div>
                </a>
              ) : (
                ""
              )}

              {menuItem.type == "link" ? (
                <Link
                  to={menuItem.path}
                  className={`sidebar-link sidebar-title link-nav d-flex ${CurrentPath.includes(menuItem.title.toLowerCase())
                      ? "active"
                      : ""
                    } ${i == selectedItem ? "sidebar-selected" : ""}`}
                  onClick={() => {
                    if (menuItem?.title == "Logout") {
                      Logout();
                      toggletNavActive(menuItem);
                      handleItemClick(i, menuItem?.title, menuItem?.type);
                    } else {
                      toggletNavActive(menuItem);
                      handleItemClick(i, menuItem?.title, menuItem?.type);
                    }
                  }}
                >
                  <>
                    {menuItem.title == "Dashboard" && (
                      <FaChartBar
                        className={`sidebar-icon ${i == selectedItem ? "sidebar-selected" : ""
                          }`}
                      />
                    )}
                    {menuItem.title == "My projects" && (
                      <FaTasks
                        className={`sidebar-icon ${i == selectedItem ? "sidebar-selected" : ""
                          }`}
                      />
                    )}
                    {menuItem.title == "My tasks" && (
                      <MdAssignment
                        className={`sidebar-icon ${i == selectedItem ? "sidebar-selected" : ""
                          }`}
                      />
                    )}
                    {menuItem.title == "Working hours" && (
                      <FaClock
                        className={`sidebar-icon ${i == selectedItem ? "sidebar-selected" : ""
                          }`}
                      />
                    )}
                    {menuItem.title == "My login hours" && (
                      <FiLogIn
                        className={`sidebar-icon ${i == selectedItem ? "sidebar-selected" : ""
                          }`}
                      />
                    )}
                    {menuItem.title == "Missing Logout list" && (
                      <FaClipboardList
                        className={`sidebar-icon ${i == selectedItem ? "sidebar-selected" : ""
                          }`}
                      />
                    )}
                    {menuItem.title == "My Absent list" && (
                      <FaUserMinus
                        className={`sidebar-icon ${i == selectedItem ? "sidebar-selected" : ""
                          }`}
                      />
                    )}
                    {menuItem.title == "Leave Approval list" && (
                      <FaClipboardCheck
                        className={`sidebar-icon ${i == selectedItem ? "sidebar-selected" : ""
                          }`}
                      />
                    )}
                    {menuItem.title == "My break hours" && (
                      <MdPause
                        className={`sidebar-icon ${i == selectedItem ? "sidebar-selected" : ""
                          }`}
                      />
                    )}
                    {menuItem.title == "Timesheet report" && (
                      <FaCalendar
                        className={`sidebar-icon ${i == selectedItem ? "sidebar-selected" : ""
                          }`}
                      />
                    )}
                    {menuItem.title == "Attendence Report" && (
                      <IoMdCalendar
                        className={`sidebar-icon ${i == selectedItem ? "sidebar-selected" : ""
                          }`}
                      />
                    )}
                    {menuItem.title == "Monthly Timesheet Report" && (
                      <FaCalendarAlt
                        className={`sidebar-icon ${i == selectedItem ? "sidebar-selected" : ""
                          }`}
                      />
                    )}
                    {menuItem.title == "Employeewise Report" && (
                      <FaUser
                        className={`sidebar-icon ${i == selectedItem ? "sidebar-selected" : ""
                          }`}
                      />
                    )}
                    {menuItem.title == "Chat" && (
                      <IoChatboxEllipses
                        className={`sidebar-icon ${i == selectedItem ? "sidebar-selected" : ""
                          }`}
                      />
                    )}
                    {menuItem.title == "Logout" && (
                      <FaSignOutAlt
                        className={`sidebar-icon ${i == selectedItem ? "sidebar-selected" : ""
                          }`}
                      />
                    )}
                  </>
                  <span
                    className={`${i == selectedItem ? "sidebar-selected" : ""}`}
                    style={{ fontSize: "13px" }}
                  >
                    {t(menuItem.title)}
                  </span>

                  {menuItem.title == "Chat" && notificationCount != "" && (
                    <Badge className="notify-all" color="dark">
                      {notificationCount > 99 ? "99+" : notificationCount}
                    </Badge>
                  )}

                  {menuItem.badge ? (
                    <label className={menuItem.badge}>
                      {menuItem.badgetxt}
                    </label>
                  ) : (
                    ""
                  )}
                </Link>
              ) : (
                ""
              )}

              {menuItem.children ? (
                <ul
                  className="sidebar-submenu"
                  style={
                    layout1 != "compact-sidebar compact-small"
                      ? menuItem?.active ||
                        CurrentPath.includes(menuItem?.title?.toLowerCase())
                        ? sidebartoogle
                          ? { opacity: 1, transition: "opacity 500ms ease-in" }
                          : { display: "block" }
                        : { display: "none" }
                      : { display: "none" }
                  }
                >
                  {menuItem.children.map((childrenItem, index) => (
                    <li key={index}>
                      {childrenItem.type == "sub" ? (
                        <a
                          href="javascript"
                          className={`${CurrentPath.includes(
                            childrenItem?.title?.toLowerCase()
                          )
                              ? "active"
                              : ""
                            }`}
                          onClick={(event) => {
                            event.preventDefault();
                            toggletNavActive(childrenItem);
                            handleItemClick(
                              i,
                              childrenItem?.title,
                              childrenItem?.type
                            );
                          }}
                        >
                          {t(childrenItem.title)}
                          <span className="sub-arrow">
                            <i className="fa fa-chevron-right"></i>
                          </span>
                          <div className="according-menu">
                            {childrenItem.active ? (
                              <i className="fa fa-angle-down"></i>
                            ) : (
                              <i className="fa fa-angle-right"></i>
                            )}
                          </div>
                        </a>
                      ) : (
                        ""
                      )}

                      {childrenItem.type == "link" ? (
                        <Link
                          to={childrenItem.path}
                          className={`${CurrentPath.includes(
                            childrenItem?.title?.toLowerCase()
                          )
                              ? "active"
                              : ""
                            }`}
                          onClick={() => {
                            toggletNavActive(childrenItem);
                            handleItemClick(
                              i,
                              childrenItem?.title,
                              childrenItem?.type
                            );
                          }}
                        >
                          <span style={{ fontSize: "13px" }}>
                            {t(childrenItem.title)}
                          </span>
                        </Link>
                      ) : (
                        ""
                      )}

                      {childrenItem.children ? (
                        <ul
                          className="nav-sub-childmenu submenu-content"
                          style={
                            CurrentPath.includes(
                              childrenItem?.title?.toLowerCase()
                            ) || childrenItem.active
                              ? { display: "block" }
                              : { display: "none" }
                          }
                        >
                          {childrenItem.children.map((childrenSubItem, key) => (
                            <li key={key}>
                              {childrenSubItem.type == "link" ? (
                                <Link
                                  to={childrenSubItem.path}
                                  className={`${CurrentPath.includes(
                                    childrenSubItem?.title?.toLowerCase()
                                  )
                                      ? "active"
                                      : ""
                                    } ${i == selectedItem ? "sidebar-selected" : ""}`}
                                  onClick={() => {
                                    toggletNavActive(childrenSubItem);
                                    handleItemClick(
                                      i,
                                      childrenSubItem?.title,
                                      childrenSubItem?.type
                                    );
                                  }}
                                >
                                  <span
                                    className={`${i == selectedItem ? "sidebar-selected" : ""
                                      }`}
                                  >
                                    {t(childrenSubItem.title)}
                                  </span>
                                </Link>
                              ) : (
                                ""
                              )}
                            </li>
                          ))}
                        </ul>
                      ) : (
                        ""
                      )}
                    </li>
                  ))}
                </ul>
              ) : (
                ""
              )}
            </li>
          ))}
        </Fragment>
      ))}
    </>
  );
};

export default SidebarMenuItems;
